/**
 * HTML `id` on `<form>` so modal submit buttons can use the `form` attribute.
 * Missing Info and Denied tabs are both mounted (hidden) — they must not share one id
 * or the browser binds `form="…"` to the first form in the document.
 */
export const UNDERWRITING_MISSING_INFO_FORM_ID = 'underwriting-email-checkbox-missing-info-form'
export const UNDERWRITING_DENIED_FORM_ID = 'underwriting-email-checkbox-denied-form'
export const CHECKLIST_TEMPLATE_FORM_ID = 'underwriting-checklist-template-form'
